import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { check } from "@tql/ui-components-react/untitled/icons";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

export const CancelDispatchModal = ({
	onClose,
	isOpen,
}: {
	onClose: () => void;
	isOpen: boolean;
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			onClose={onClose}
			onConfirm={onClose}
			showCancelButton={false}
			title={`Cancel Dispatch`}
			type={"confirmation"}
			width={"20%"}
		>
			<div>
				<SvgIcon
					icon={check}
					size={"xxlarge"}
					style={{
						color: "var(--kendo-color-success)",
						marginRight: "var(--kendo-spacing-2)",
					}}
				/>
				Dispatch canceled successfully.
			</div>
		</TraxModal>
	);
};
